<template>
  <div :class="[`${direction}Input`]">
    <span v-if="name" id="inputTitle">
      {{ name }}
    </span>

    <b-form-input
      id="formInput"
      v-model="currentValue"
      :placeholder="placeholder"
      :type="type"
      :disabled="disabled"
      :plaintext="plaintext"
      :readonly="readonly"
      @input="onInput"
    ></b-form-input>
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    name: {
      type: String,
      default: null
    },

    placeholder: {
      type: String,
      default: null
    },

    type: {
      type: String,
      default: 'text'
    },

    disabled: {
      type: Boolean,
      default: false
    },

    plaintext: {
      type: Boolean,
      default: false
    },

    readonly: {
      type: Boolean,
      default: false
    },

    direction: {
      type: String,
      default: 'horizontal'
    },

    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true,
      default: null
    }
  },

  data() {
    return {
      currentValue: this.value
    }
  },

  methods: {
    onInput() {
      this.$emit('input', this.currentValue)
    }
  }
}
</script>

<style lang="scss" scoped>
$text-color: #8b69a9;
$border-color: #8b69a9;

#inputTitle {
  margin-right: 10px;
}

.horizontalInput {
  display: grid;
  grid-template-columns: 30% 30%;
  margin-left: 5%;
}

#formInput {
  border-radius: 10px;
  border: 2px $border-color solid;
}
</style>
